// Shape helpers for the master data lists served from the API. The values
// themselves live in the database (masterdata collection) so HR can maintain
// them from the Master Data screen without a release — nothing here hardcodes
// an option list.

export const MASTER_DATA_KEYS = [
  'position_title',
  'department',
  'location',
  'hiring_track',
  'position_type',
];

export const MASTER_DATA_LABELS = {
  position_title: 'Position Title',
  department: 'Department',
  location: 'Location',
  hiring_track: 'Hiring Track',
  position_type: 'Reason for Opening',
};

export const EMPTY_MASTER_DATA = Object.fromEntries(MASTER_DATA_KEYS.map(k => [k, []]));

// JetaSelect expects { name, value } — not { label, value }.
export function toOptions(rows = []) {
  return rows.filter(r => r.is_active).map(r => ({ name: r.value, value: r.value }));
}
